<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisBottomSheet from 'dashboard/components-next/lais/LaisBottomSheet.vue';
import VisitingBlockedSheet from 'dashboard/components-next/lais/VisitingBlockedSheet.vue';

defineProps({
  show: { type: Boolean, default: false },
  visit: { type: Object, default: null },
  reason: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
  isDone: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
});

const emit = defineEmits(['close', 'notify', 'similar']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisBottomSheet :show="show" title="Visita bloqueada" @close="emit('close')">
    <VisitingBlockedSheet
      :visit="visit"
      :reason="reason"
      :is-loading="isLoading"
      :is-done="isDone"
      :error-message="errorMessage"
      @notify="emit('notify')"
      @similar="emit('similar')"
      @close="emit('close')"
    />
  </LaisBottomSheet>
</template>
